import { Dashboard } from "../../components/Pages/Dashboard";

export const DashboardPage = () => {
  return <Dashboard />;
};
